import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import axios from "axios";
import "./VerifyEmail.css";
import Sidebar from '../components/Layout/Sidebar';
import Header from '../components/Layout/Header';
import { toast } from 'react-toastify';
import { useAuth } from '../contexts/AuthContext';

const VerifyEmail = () => {
    const [searchParams] = useSearchParams();
    const [status, setStatus] = useState("loading");
    const [Message, setMessage] = useState("");
    const navigate = useNavigate();
    const [sidebarOpen, setSidebarOpen] = useState(true);
    const [loading, setLoading] = useState(false);
    const { verifyMail } = useAuth();

    useEffect(() => {
        verifyEmail()

    }, [searchParams]);


    const verifyEmail = async () => {
        setLoading(true);

        try {
            const key = searchParams.get("verify_key");

            console.log("tokey", key)

            if (!key) {
                setStatus("error");
                return;
            }
            await verifyMail(key);
            // await axios.get(
            //     `https://dev.whiterobe.in/api_ppm/api/v1/auth/verify_mail?=${key}`
            // );
            setStatus("success");
            // setMessage(error.response?.data?.message)

            toast.success('Verified successful!');
        } catch (error) {
            setStatus("error");
            // setMessage(error.response?.data?.error)
            // toast.error(error.response?.data?.error || 'Registration failed');
        } finally {
            setLoading(false);
        }
    };

    return (


        <div className="flex h-screen bg-gray-100">
            <div className="flex-1 flex flex-col overflow-hidden">
                <main className="flex-1 overflow-x-hidden overflow-y-auto bg-gray-100 p-6">
                    <div className="verify-page">
                        <div className="verify-card">
                            {status === "loading" && (
                                <>
                                    <div className="loader"></div>
                                    <h2>Verifying your email...</h2>
                                </>
                            )}

                            {status === "success" && (
                                <>
                                    <div className="success-icon">✓</div>
                                    <h1>Email Verified!</h1>
                                    <p>
                                        Your email address has been successfully verified.
                                    </p>

                                    <button
                                        className="nav-link-btn login-btn"
                                        onClick={() => navigate("/login")}
                                    >
                                        Continue to Login
                                    </button>
                                </>
                            )}

                            {status === "error" && (
                                <>
                                    <div className="error-icon">✕</div>
                                    <h1>Verification Failed</h1>
                                    <p>
                                        Invalid Details
                                    </p>
                                </>
                            )}
                        </div>
                    </div>
                </main>
            </div>
        </div>


    );
}

export default VerifyEmail;